import { FormattedMessage } from "react-intl";

export const PickUpWhereYouLeftOffInJiraText = () => (
    <FormattedMessage
        id="JiraSoftwarePageTemplate.loggedInHero.pickUpWhereYouLeftOff"
        defaultMessage="Pick up where you left off in Jira."
    />
);
